import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.functional.interceptor';
import { errorInterceptor } from './core/interceptors/error.functional.interceptor';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material';
import Aura from '@primeuix/themes/aura';
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap';
import { CoreModule } from './core/core.module';
import { MessageService, ConfirmationService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]), withFetch()),
    provideClientHydration(),
    importProvidersFrom(CoreModule),
    provideDaterangepickerLocale({
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      clearLabel: 'Clear',
      format: 'YYYY-MM-DD',
      displayFormat: 'MMM DD, YYYY',
      firstDay: 1, // Monday
    }),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: false
        }
      }
    })
  ]
};
